import { useLocation, Outlet, Navigate } from 'react-router-dom';
import useAuth from '../hook/useAuth';
import { jwtDecode } from "jwt-decode";
import Cookies from 'js-cookie';
import { isTokenExpired } from '../utils/isTokenExpired';

type Props = {
    allowedRoles: string[];
}

const RequriedAuth = ({ allowedRoles }: Props) => {
    const { setAuth }: any = useAuth();
    const location = useLocation();
    const role = Cookies.get("role-elministry") || "";
    const token = Cookies.get("token-elministry");

    if (token) {
        const jsonData: any = jwtDecode(token);
        const expires = jsonData.exp;
        if (isTokenExpired(expires)) {
            setAuth(null);
            Cookies.remove("token-elministry");
            Cookies.remove("role-elministry");
            Cookies.remove("userId-elministry");
            Cookies.remove("profileImg-elministry");
            return (
                <Navigate to="/login" state={{ from: location }} replace />
            );
        }
    }

    return (
        token
            ? allowedRoles?.some((allowedRole: string) => allowedRole?.toLowerCase()?.includes(role?.toString()?.toLowerCase()))
                ? <Outlet />
                : <Navigate to="/not-found" replace={true} />
            : <Navigate to="/login" state={{ from: location }} replace />
    );
}

export default RequriedAuth;